import { useStaticQuery, graphql } from "gatsby"

export const useNavLinks = (navName = "great_expectations") => {
  const data = useStaticQuery(
    graphql`
      query {
        allContentfulMainNav {
          nodes {
            logo {
              id
              gatsbyImageData(width: 210)
              description
            }
            id
            navTitle
            links {
              ... on ContentfulNavDropdown {
                id
                dropdownTitle
                dropdownMainLink
                __typename
                links {
                  ... on ContentfulNavDropdown {
                    id
                    dropdownTitle
                    dropdownMainLink
                    __typename
                    links {
                      ...ActionFragment
                    }
                  }
                  ... on ContentfulAction {
                    ...ActionFragment
                    actionEvent
                    iconSize
                  }
                }
              }
              ... on ContentfulAction {
                ...ActionFragment
                actionEvent
                iconSize
              }
            }
          }
        }
      }
    `,
  )
  const filteredNav = data.allContentfulMainNav.nodes.find((node) => node.navTitle === navName)
  return { contentfulMainNav: filteredNav }
}
